'use client'

import dynamic from 'next/dynamic'

// Client-only chart: its library is fetched only when a desktop screen actually renders it, never on phones or before first paint
const DailyLineChartLazyMolecule = dynamic(() => import('@/components/molecules/item/chart/daily-line'), { ssr: false })

export default DailyLineChartLazyMolecule
